<mat-button-toggle-group
  [value]="selectedTool$ | async"
  (change)="setTool($event.value)"
>
  @for (button of buttons$ | async; track button) {
    <mat-button-toggle
      class="toolbar-button"
      [value]="button.toolName"
      [matTooltip]="button.tooltip"
    >
      <mat-icon [h3CustomIcon]="button"> </mat-icon>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
